import {AgentTimelineView} from "../../../agent/timeline.tsx";
import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {validateAsofSearchParams} from "../../../tstzspan.ts";
import {useBomb} from "../../../bomb/bomb.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {DateBrowser} from "../../../components/Dates.tsx";
import {useStampAgentMutation} from "../../../tq/tqx.tsx";
import {TimelineStampInput} from "../../../stamp/timelineStampInput.tsx";
import {useCallback, useState} from "react";
import {GenericFlavorlessStampSpawnFood} from "../../../stamp/genericFlavorlessStampSpawnFood.tsx";
import {Stack} from "@mui/joy";
import {SortOrder} from "../../../rpc/webrpc-client.gen.ts";
import {IconToggleSwitch, ToggleBar} from "../../../components/ToggleBar.tsx";
import {sortOrderIcons} from "../../../tq/tqutil.tsx";

function AgentTimelinePage() {
    const {id: who} = Route.useParams();
    const searchParams = Route.useSearch();
    const navigate = useNavigate();
    const bomb = useBomb();
    const {mutateAsync: performStamp} = useStampAgentMutation();
    const doStamp = useCallback((gf: GenericFlavorlessStampSpawnFood) =>
        performStamp({food: {agentId: who, ...gf}}), [performStamp, who]);
    const [sortOrder, setSortOrder] = useState<SortOrder>(SortOrder.enum.DESC);

    return <PageShell>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>

                <ToggleBar>
                    <DateBrowser day={searchParams.asof} onDayChange={(newDay) => {
                        navigate({to: Route.to, params: {id: who}, search: {...searchParams, asof: newDay}})
                            .catch(bomb);
                    }} sx={{mt: 1.2, mb: 0.4}}/>
                    <IconToggleSwitch icons={sortOrderIcons} value={sortOrder} dispatchValue={(next) => {
                        setSortOrder(next);
                    }}/>
                </ToggleBar>

                <TimelineStampInput addStamp={doStamp}/>
            </Stack>
        </PageHeader>
        <PageBody>
            <AgentTimelineView who={who} day={searchParams.asof}/>
        </PageBody>
    </PageShell>
}

export const Route = createFileRoute("/_auth/agent/$id/timeline")({
    component: AgentTimelinePage,
    validateSearch: validateAsofSearchParams,
});
